// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
//import Turbolinks from "turbolinks"
//import * as ActiveStorage from "@rails/activestorage"
import "channels"

window.global = window;
global.$ = require("jquery");

require("jquery");
require("jquery-ui");

Rails.start()
//Turbolinks.start()
//ActiveStorage.start()

window.bootstrap = require('js/services/bootstrap/dist/js/bootstrap.bundle.js');

require("js/services/jquery.magnific-popup");

import '../js/social_network/fluidbook.js' 
import '../js/index/turnjs' 

require("js/welcome_2023.js");





//global.$ = require("jquery");
//
//
//require("js/welcome_2023.js");
//
//require("js/services/jquery.magnific-popup");
//
//import '../js/social_network/fluidbook.js' 
//import '../js/index/turnjs' 
//
//require("js/welcome_2023.js");


